import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";

const SmartTVAppAlertModal = ({ isAlertModalOpened, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isAlertModalOpened} centered backdrop={false}>
            <div className="card container-fluid">
                <div className="card-body px-2">
                    <div className="title-area text-center dark-grey-text">
                        <div className="d-flex flex-column">
                            <span>
                                {t("스마트_티브이_안내_문구_5", { ns: "live" })}
                            </span>
                        </div>
                    </div>
                    <div className="content-area dark-grey-text font-md">
                        <span className="mb-1">
                            {t("스마트_티브이_안내_문구_6", { ns: "live" })}
                        </span>
                        <span className="mb-2">
                            {t("스마트_티브이_안내_문구_7", { ns: "live" })}
                        </span>
                        <span className="small mb-1">
                            {t("스마트_티브이_안내_문구_8", { ns: "live" })}
                        </span>
                    </div>
                    <button type="button" className="btn btn-md green white-text py-1 px-2" onClick={() => handleSelectedFunc({ selectedFunc: "TRY_CONN_APP" })}>{t("확인", { ns: "common" })}</button>
                </div>
            </div>
        </Modal>
    );
}

export default SmartTVAppAlertModal;